<div style="position: relative; min-height: 20rem" class="{{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="devices-wrapper">
		<div class="device-chart-data">
			<div class="devices-chart-div {{ deviceCount }}" *ngFor="let config of multichartconfigurations; let i = index">
				<div *ngIf="!hasData">
					<div class="map-no-data c-portlet no-data-div">{{ nodatamessage }}</div>
				</div>
				<div *ngIf="hasData">
					<app-generic-chart
						id="device-id-{{ i }}"
						[configuration]="config"
						[colorPalette]="colorPalette"
						[data]="devicesChartData"
					>
					</app-generic-chart>
				</div>
			</div>
		</div>

		<div
			class="legend-detail {{ deviceCount }}"
			[ngClass]="{
				'device-legend-datatable': true,
				'ctv-legend': isCTV
			}"
		>
			<div class="legend-detail {{ sectionclass }}" *ngFor="let datatableConfig of multidatatableconfigurations">
				<ngx-datatable
					class="dataTable"
					[rows]="deviceLegendData"
					[columns]="datatableConfig['columns']"
					[columnMode]="'force'"
					[footerHeight]="0"
					[reorderable]="false"
					[virtualization]="false"
					[headerHeight]="38"
				>
					<ng-template ngFor let-column [ngForOf]="datatableConfig['columns']">
						<ngx-datatable-column
							name="{{ column.name }}"
							prop="{{ column.prop }}"
							[cellClass]="column.cellClass"
							[headerClass]="column.headerClass"
							[resizeable]="false"
							[sortable]="false"
						>
							<ng-template ngx-datatable-cell-template let-value="value" let-rowIndex="rowIndex" let-row="row">
								<div class="datatable-row">
									<span [attr.class]="column.headerClass"
										><span [ngClass]="getDeviceColor(row[column.prop])">{{ row[column.prop] }}</span></span
									>
									<span [attr.class]="!hasData ? 'postpend no-data' : 'postpend'">{{ column['columnSuffix'] }}</span>
									<ng-template ngFor let-complexProp [ngForOf]="column.complexProperty">
										<span [attr.class]="!hasData ? 'prepend no-data' : 'prepend'">{{ complexProp.prepend }}</span>
										<span [ngStyle]="complexProp.styles" [attr.class]="complexProp.cssClass">{{
											row[complexProp.propertyKey]
										}}</span>
										<span [attr.class]="!hasData ? 'postpend no-data' : 'postpend'">{{ complexProp.postpend }}</span>
									</ng-template>
								</div>
							</ng-template>
						</ngx-datatable-column>
					</ng-template>
				</ngx-datatable>
			</div>
		</div>
	</div>
</div>
<div *ngIf="isR1301 && isCTV" class="{{ sectionclass }} bg-color">

	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="device-completion-title">Completions</div>
	<div class="device-portlet-content" *ngIf="hasData">
		<div class="device_content_header">
			<div>started</div>
			<div>25% completed</div>
			<div>50% completed</div>
			<div>75% completed</div>
			<div>completed</div>
		</div>
		<div
			class="device_content"
			*ngFor="
				let deviceNetwork of deviceNetworks
					| paginate: { id: 'devices_pagination', itemsPerPage: 8, currentPage: pageId };
				index as i;
				let l = count
			"
		>
			<div class="device_details">
				<p class="device_name" [ngClass]="getDeviceColor(deviceNetwork.deviceName)">{{ deviceNetwork.deviceName }}</p>
	        </div>
			<div class="progress_bar">
				<div class="device_progressbar_content">
					<div class="device_progressbar_header">100%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLine"></div>
					</div>

					<div class="device_progressbar_footer">
						<div class="values"></div>
					</div>
				</div>

				<div class="device_progressbar_content">
					<div class="device_progressbar_header">{{ deviceNetwork.percent25 }}%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLine"></div>
					</div>

					<div class="device_progressbar_footer">
						<div class="values">{{ deviceNetwork.value25 | number }} views</div>
					</div>
				</div>
				<div class="device_progressbar_content">
					<div class="device_progressbar_header">{{ deviceNetwork.percent50 }}%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLine"></div>
					</div>

					<div class="device_progressbar_footer">
						<div class="values">{{ deviceNetwork.value50 | number }} views</div>
					</div>
				</div>

				<div class="device_progressbar_content">
					<div class="device_progressbar_header">{{ deviceNetwork.percent75 }}%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLine"></div>
					</div>

					<div class="device_progressbar_footer">
						<div class="values">{{ deviceNetwork.value75 | number }} views</div>
					</div>
				</div>

				<div class="device_progressbar_content">
					<div class="device_progressbar_header">{{ deviceNetwork.percent100 }}%</div>
					<div class="percent">
						<div class="drawCircle"></div>
						<div class="horizontalLineLast"></div>
					</div>

					<div class="device_progressbar_footer">
						<div class="values">{{ deviceNetwork.value100 | number }} views</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="!hasData" style="display: table; min-height: 800px; width: 100%;">
		<div class="no-data-text">
			<p>No Data Available</p>
		</div>
	</div>
</div>
